import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FindLoad,
  useGlobalStyles,
  useGlobalTextStyles,
  useModal,
} from 'utils';
import { CreateChancel, ValidationInput } from 'components';
import {
  customerPaymentActions,
  httpRequestsOnLoadActions,
  httpRequestsOnSuccessActions,
} from 'store';
import { authService } from '../../../store/customerPayment/customerPayment.service';
import { customerRate } from '../../loads/transactions/styles';

const ACTION_TYPE = 'EDIT_CUSTOMER_PMT_DESC';
export const EditLoadDesc = ({ info }) => {
  const globalWrapper = useGlobalStyles();
  const globalText = useGlobalTextStyles();
  const globalStyles = useGlobalStyles();
  const classes = customerRate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const { close } = useModal();
  const dispatch = useDispatch();
  const loader = FindLoad(ACTION_TYPE);
  const { customerPaymentById } = useSelector((state) => ({
      customerPaymentById: state.customerPayments.customerPaymentById,
    }),
  );

  useEffect(() => {
    if (info?.description) {
      setInputs({ description: info?.description });
    }
  }, [info]);
  const handleChange = e => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    error === e.target.name && setError('');
  };
  const handleEdit = async () => {
    if (inputs?.description) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      dispatch(httpRequestsOnLoadActions.appendLoading(ACTION_TYPE));
      try {
        await authService.editCustomerPmtDescription(customerPaymentById?.id, info?.id, inputs?.description);
        dispatch(customerPaymentActions.getCustomerPaymentLoad(customerPaymentById?.id));
        close();
        dispatch(httpRequestsOnLoadActions.removeLoading(ACTION_TYPE));
        dispatch(httpRequestsOnSuccessActions.appendSuccess(ACTION_TYPE));
      } catch (e) {
        close();
        dispatch(httpRequestsOnLoadActions.removeLoading(ACTION_TYPE));
      }
    } else {
      setError('description');
    }
  };

  return (
    <div style={{ width: '495px!important' }}>
      <p className={globalText.modalTitle}>Edit Description</p>
      <div className={classes.sectionTop}>
        <ValidationInput
          className={inputs.description ? classes.inputDescriptionBlue : classes.inputDescription}
          onChange={handleChange}
          typeError={error === 'description' ? ' ' : ''}
          variant={'outlined'}
          name={'description'}
          Length={200}
          value={inputs.description}
          label={'Description here...'}
          type={'text'}
          multiline={true}
        />
        <div className={globalStyles.flexEnd}>
          <p
            className={globalStyles.maxCharacter}>{`Max ${inputs.description ? inputs.description.length : 0}/200 characters`}</p>
        </div>
      </div>
      <CreateChancel
        loader={!!loader.length}
        classes={globalWrapper.buttonsStyle}
        create={'Save'}
        chancel={'Cancel'}
        onCreate={handleEdit}
        onClose={close}
      />
    </div>
  );
};